import { getFirestore, collection, doc, getDoc, getDocs, updateDoc, deleteDoc, setDoc, query, orderBy, limit, startAfter, endBefore, onSnapshot, deleteField } from "firebase/firestore";
import { getStorage, ref, uploadString, getDownloadURL, deleteObject } from "firebase/storage";
import { v4 as uuidv4 } from "uuid";

const db = getFirestore();

const storageInstance = getStorage()
const storageImages = ref(storageInstance, "exercises-images/");

export default {
    state: {
        pwoList: [],
        pwoStatusImage: 0,
        pwoModuleUnsubscribe: {},
        pwoCounterReproductor: {},
        unsubscribePWOList: null,
        unsubscribePWOCounterReproductor: null
    },
    mutations: {
        SET_VALUE_LOADING_IMAGE_PWO(state, value) {
            state.pwoStatusImage = value
        },
        SET_PWO_LIST(state, pwoList) {
            state.pwoList = pwoList;
        },
        SET_PWO_COUNTER_REPRODUCTOR(state, counterReproductor) {
            state.PWOCounterReproductor = counterReproductor;
        },
        SET_UNSUBSCRIBE_PWO_LIST(state, unsubscribe) {
            state.unsubscribePWOList = unsubscribe;
        },
        GO_UNSUBSCRIBE_PWO_LIST(state) {
            state.unsubscribePWOList();
        },
        SET_UNSUBSCRIBE_PWO_COUNTER_REPRODUCTOR(state, unsubscribe) {
            state.unsubscribePWOCounterReproductor = unsubscribe;
        },
        GO_UNSUBSCRIBE_PWO_COUNTER_REPRODUCTOR(state) {
            state.unsubscribePWOCounterReproductor();
        },
        DELETE_PWO_FROM_ARRAY(state, pwo) {
            const index = state.pwoList.indexOf(pwo);
            if (index > -1) {
                state.pwoList.splice(index, 1);
            }
        }
    },
    actions: {
        GetPWO({ commit }) {
            return new Promise((resolve, reject) => {
                getDocs(collection(db, "ProfessionalWorkouts")).then((querySnapshot) => {
                        var professionalWorkouts = [];
                        querySnapshot.forEach((doc) => {
                            let pwo = doc.data();
                            pwo.id = doc.id;
                            professionalWorkouts.push(pwo);
                        });
                        commit("SET_PWO_LIST", professionalWorkouts);
                        resolve(professionalWorkouts);
                    }).catch((err) => {
                        reject(err)
                    })
            });
        },
        GetPWOPaginatedFirstPage({ commit, getters }, itemsPerPage) {
            return new Promise(async(resolve, reject) => {
                if (getters.getProfessionalWorkouts.length > 0) {
                    commit("GO_UNSUBSCRIBE_PWO_LIST");
                }
                                 const q = query(collection(db, "ProfessionalWorkouts"), orderBy('name.ENG'), limit(itemsPerPage));
                 let unsubscribe = onSnapshot(q, (querySnapshot) => {
                        let professionalWorkouts = [];
                        querySnapshot.forEach((doc) => {
                            let pwo = doc.data()
                            pwo.id = doc.id;
                            professionalWorkouts.push(pwo);
                        });
                        commit("SET_PWO_LIST", professionalWorkouts);
                        resolve(professionalWorkouts);
                    },
                    (error) => {
                        reject(error);
                    }
                );
                commit("SET_UNSUBSCRIBE_PWO_LIST", unsubscribe);
            });
        },
        GetPWONextPage({ commit, getters }, itemsPerPage) {
            return new Promise(async(resolve, reject) => {
                commit("GO_UNSUBSCRIBE_PWO_LIST");
                                 const q = query(collection(db, "ProfessionalWorkouts"), orderBy('name.ENG'), startAfter(getters.getProfessionalWorkouts[getters.getProfessionalWorkouts.length - 1].name['ENG']), limit(itemsPerPage));
                 let unsubscribe = onSnapshot(q, (querySnapshot) => {
                        let professionalWorkouts = [];
                        querySnapshot.forEach((doc) => {
                            let pwo = doc.data()
                            pwo.id = doc.id;
                            professionalWorkouts.push(pwo);
                        });
                        console.log(professionalWorkouts);
                        if (professionalWorkouts.length > 0) {
                            commit("SET_PWO_LIST", professionalWorkouts);
                        }
                        resolve(professionalWorkouts);
                    },
                    (error) => {
                        reject(error);
                    }
                );
                commit("SET_UNSUBSCRIBE_PWO_LIST", unsubscribe);
            });
        },
        GetPWOPrevPage({ commit, getters }, itemsPerPage) {
            return new Promise(async(resolve, reject) => {
                commit("GO_UNSUBSCRIBE_PWO_LIST");
                                 const q = query(collection(db, "ProfessionalWorkouts"), orderBy('name.ENG', 'desc'), startAfter(getters.getProfessionalWorkouts[0].name['ENG']), limit(itemsPerPage));
                 let unsubscribe = onSnapshot(q, (querySnapshot) => {
                        let professionalWorkouts = [];
                        querySnapshot.forEach((doc) => {
                            let pwo = doc.data()
                            pwo.id = doc.id;
                            professionalWorkouts.push(pwo);
                        });
                        commit("SET_PWO_LIST", professionalWorkouts);
                        resolve(professionalWorkouts);
                    },
                    (error) => {
                        reject(error);
                    }
                );
                commit("SET_UNSUBSCRIBE_PWO_LIST", unsubscribe);
            });
        },
        GoUnsuscribePwoList({ commit }) {
            commit("GO_UNSUBSCRIBE_PWO_LIST");
        },
        GoUnsuscribePwoCounterReproductor({ commit }) {
            commit("GO_UNSUBSCRIBE_PWO_COUNTER_REPRODUCTOR");
        },
                UploadImagePWO({ commit }, pwo) {
            return new Promise(async (resolve, reject) => {
                try {
                    let random = uuidv4();
                    let storageRef = ref(storageInstance, `exercises-images/${random}`);
                    console.log('storageRef', storageRef.name);
                    
                    // Upload the string
                    await uploadString(storageRef, pwo.image, "data_url");
                    
                    // Get the download URL
                    const downloadURL = await getDownloadURL(storageRef);
                    resolve({ link: downloadURL });
                } catch (error) {
                    console.log('error', error);
                    reject(error);
                }
            });
        },
        CreatePWO({}, pwo) {
            return new Promise(async(resolve, reject) => {
                                 const newDocRef = doc(collection(db, "ProfessionalWorkouts"));
                 pwo.id = newDocRef.id;
                 await setDoc(newDocRef, pwo)
                    .then(async(res) => {
                        await updateDoc(doc(db, "countersAnalytics", "pwoReproductions"), {
                                [newPWO.id]: 0 })
                            .then((resCounter) => {
                                console.log('newPWO.id', newPWO.id);
                                resolve(newDocRef.id);
                            })
                            .catch((errCounter) => {
                                reject(errCounter);
                            });
                    })
                    .catch((err) => {
                        reject(err);
                    });
            })
        },
        DeletePWO({}, pwo) {
            return new Promise(async(resolve, reject) => {
                await deleteDoc(doc(db, "ProfessionalWorkouts", pwo.id))
                    .then((res) => {
                        updateDoc(doc(db, "countersAnalytics", "pwoReproductions"), {
                            [pwo.id]: deleteField()
                        })
                        resolve(pwo.id);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        UpdatePWO({}, pwo) {
            return new Promise(async(resolve, reject) => {
                if (pwo.selectedImage) {
                    delete pwo.selectedImage
                }
                await updateDoc(doc(db, "ProfessionalWorkouts", pwo.id), pwo)
                    .then((res) => {
                        resolve(pwo.id);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        DisablePWO({}, pwo){
            return new Promise(async(resolve, reject) => {
                try {
                    await updateDoc(doc(db, "ProfessionalWorkouts", pwo.id), {
                      enabled: !pwo.enabled
                    })
                    resolve(pwo.id);
                } catch (error) {
                    reject(error);
                }
            });
      
        }

    },
    getters: {
        getProfessionalWorkouts(state) {
            return state.pwoList;
        },
        getLoadingImagePwo(state) {
            return state.pwoStatusImage;
        },
        getPWOCounterReproductor(state) {
            return state.pwoCounterReproductor;
        }
    }
}